
import 'instantsearch.css/themes/satellite.css';
import './App.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';

import classes from './customAppStyle.module.css';
import { useEffect, useState, useMemo } from 'react';
import Topbar from "./components/topbar";
import {
  Navigate,
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,

} from "react-router-dom";
import { isFeatureHidden } from "./helpers/features";
import Customers from "./routes/customers/customers";
import { UpdateRequestsQueue } from "./routes/customers/customer_update_requests";
import Home from "./routes/home";
import Order from "./routes/orders/order";

import { collection, onSnapshot } from "firebase/firestore";


import { AppConfigContext, ConfigContext, MyUserDataContext, GlobalDataContext } from "./contexts";

import {
  getAuth,
  OAuthProvider,
  signInWithRedirect,
  User,
} from "firebase/auth";
import Orders from "./routes/orders/orders";
import AddOrder from './routes/add_order';



import { BrowserAuthError, InteractionRequiredAuthError, PublicClientApplication, SsoSilentRequest } from '@azure/msal-browser';
import { Configuration } from "@azure/msal-browser";
import { httpsCallable } from "firebase/functions";
import { AppShell, MantineProvider, Loader, Center, Stack, ColorSchemeScript, Divider, ThemeIcon, Burger, ScrollArea, } from '@mantine/core';
import { MainLinks } from './components/mainlinks';

import { ModalsProvider } from '@mantine/modals';

import {
  Paper,
  Title,
  Text,
  Button,
  Container,
  Group,
  Image
} from '@mantine/core';
import { IconAntenna, IconBeach, IconBrandWhatsapp, IconBuildingWarehouse, IconBrandWindows, IconBulb, IconHandGrab, IconMessages, IconMoneybag, IconPackage, IconReport, IconReportMoney, IconScale, IconSettings, IconSpeakerphone, IconTool, IconUserCog, IconUsers } from '@tabler/icons-react';
import { IconHome, IconFileText } from '@tabler/icons-react';
import { Notifications } from '@mantine/notifications';
import { resolveAvailableRouteKeys } from './helpers/routeAccess';
import { AppConfigType, ClaimType, ConfigDataType, CustomClaims, CustomClaimsRequest, CustomClaimsResult, Fund, GlobalDataType, PresenceContextType, PresenceData, ProductType, UserDataType, Viewer } from './types';
import { Client } from '@microsoft/microsoft-graph-client';
import TransactionForm from './routes/transactions/transaction_form';
import FlowEditor from './routes/settings/flow_editor';
import SecuritiesList from './routes/securities/SecuritiesList';
import TransactionsList from './routes/transactions/TransactionsList';
import TransactionDetails from './routes/transactions/transaction_details';
import Settings from './routes/settings/settings';
import CustomerMain from './routes/customers/customer';
import { EmailLogin } from './components/email_login';
import { VersionChecker } from './components/version_checker';
import Reports from './routes/reports/reports';
import GenevaReportPrintPage from './routes/reports/GenevaReportPrintPage';
import { app, auth, firestore, functions } from './helpers/firebaseContext';
import FirebaseProvider from './helpers/firebaseProvider';
// import CommunicationForm from './routes/communication/CommunicationForm';
import Services from './routes/services/kfhtrade_services_list';
import AddService from './routes/services/add_kfhtrade_service';
import ServicePage from './routes/base_service/service';
import CreateCampaign from './routes/campaigns/create_campaign';
import Campaigns from './routes/campaigns/campaigns';
import CreateFeedback from './routes/feedbacks/create_feedback';
import AddFundReport from './pages/fundReports/add_fund_report';
import FundReportsList from './pages/fundReports/fund_reports_list';
import RMsListPage from './routes/settings/RMsListPage';

import ManualConsent from './routes/manual/ManualConsent';

import Trades from './routes/trades/trades';
import { useDisclosure } from '@mantine/hooks';
import AddIpo from './routes/ipos/add_ipo';
import IposRequests from './routes/ipos/ipo_requests';
import ipoRequestInfo from './routes/ipos/ipo_request_info';
import IpoRequestPage from './routes/ipos/ipo_request';

import FundsList from './routes/funds/funds_list';
import ProductCatalogue from './routes/products/product_catalogue';
import GenevaRequests from './routes/geneva_requests/geneva_requests';
import GenevaRequest from './routes/geneva_requests/geneva_request';
import GenevaRequestCreate from './routes/geneva_requests/geneva_request_create';
import GenevaRequestBulkCreate from './routes/geneva_requests/geneva_request_bulk_create';
import ExpenseManagers, { ExpenseManagerDetail } from './routes/geneva_requests/expense_managers';
import ExpenseManagerCreate from './routes/geneva_requests/expense_manager_create';
import { PresenceTracker } from './components/presence_tracker';
import VerifyQR from "./routes/qr/verify";

import KYCConfiguration from './routes/kyc/kyc_configuration';
import AddPageForm from './routes/kyc/add_page_form';
import AddProductForm from './routes/kyc/add_product_form';
import KYCDetailsPage from './components/customer_kyc_only_page';
import CramConfiguration from './routes/cram_configuration/cram_configuration';
import Portfolios from './routes/portfolios/portfolios';
import { BsBriefcase } from 'react-icons/bs';
import AddPortfolio from './routes/portfolios/add_portfolio';
import { CustomerSpotlight } from './components/customer_spotlight';
import WhatsappInbox from './routes/whatsapp/whatsapp_inbox';
import Ctc from './routes/ctc/ctc';
import CtcOrders, { CtcWatchList } from './routes/ctc/ctc_orders';
import CtcOrder from './routes/ctc/ctc_order';
import CtcNewOrder from './routes/ctc/ctc_new_order';
import CtcBackOffice from './routes/ctc/ctc_backoffice';
import { CtcReports } from './routes/ctc/ctc_reports';
import CtcTransactions from './routes/ctc/ctc_transactions';
import EtfPage from './routes/etf/etf_page';
import GlobalDpmRebalancePage from './routes/trades/global_dpm_rebalance';

//set environment type
// type DevEnvironment = 'test' | 'production' | 'local';


function CustomerMainRoute() {
  const { id } = useParams();
  return <CustomerMain key={id ?? "customer"} />;
}




export const routesList: any = {
  "common": [{
    to: "/",
    icon: <ThemeIcon color="blue" variant="light"><IconHome size={16} /></ThemeIcon>,
    label: 'Home',
    route: <Route key="root" path="/" element={<Home />} />,
    sideBar: !isFeatureHidden("home"), // VITE_HIDDEN_FEATURES=home: no Home link; "/" redirects (see renderedRoutes)
    order: 1,
  },

  ],

  "customers": [{
    to: "/customers",
    icon: <ThemeIcon color="teal" variant="light"><IconUsers size={16} /></ThemeIcon>,
    label: 'Customers',
    route: <Route key="customers_root" path="/customers" >
      <Route key="customers" index element={<Customers />} />
      <Route key="customers/update_requests" path="update_requests" element={<UpdateRequestsQueue />} />
      <Route key="customers/id" path=":id" element={<CustomerMainRoute />} />
      <Route key="customers/id/kyc/kycID" path=":customerId/kyc/:kycId" element={<KYCDetailsPage />} />

    </Route>,
    sideBar: true,
    order: 2,



  },
  {
    to: "/customers/update_requests",
    icon: <ThemeIcon color="orange" variant="light"><IconUserCog size={16} /></ThemeIcon>,
    label: 'Update Requests',
    sideBar: true,
    order: 2.1,
  },],
  "orders": [
    {
      to: "/orders", route: <Route key="orders_root" path="/orders" >
        <Route key="orders" index element={<Orders />} />
        <Route key="orders/id" path=":id" element={<Order />} />
      </Route>,
      icon: <ThemeIcon color="violet" variant="light"><IconMessages size={16} /></ThemeIcon>,
      label: 'Orders',
      sideBar: true,
      order: 3,
    },
    {
      to: "/add_order", route: <Route key="add_order_root" path="/add_order"  >
        <Route key="add_order" index element={<AddOrder />} />
        <Route key="add_order/id" path=":civilIDParam" element={<AddOrder />} />
      </Route>,

    },
  ],
  "geneva_requests": [{
    to: "/geneva_requests",
    icon: <ThemeIcon color="teal" variant="light"><IconFileText size={16} /></ThemeIcon>,
    label: 'Geneva',
    route: <Route key="geneva_requests_root" path="/geneva_requests" >
      <Route key="geneva_requests" index element={<GenevaRequests />} />
      <Route key="geneva_requests/create" path="create" element={<GenevaRequestCreate />} />
      <Route key="geneva_requests/bulk-create" path="bulk-create" element={<GenevaRequestBulkCreate />} />
      <Route key="geneva_requests/expense_managers" path="expense_managers" element={<ExpenseManagers />} />
      <Route key="geneva_requests/expense_managers/create" path="expense_managers/create" element={<ExpenseManagerCreate />} />
      <Route key="geneva_requests/expense_managers/id" path="expense_managers/:id" element={<ExpenseManagerDetail />} />
      <Route key="geneva_requests/id" path=":id" element={<GenevaRequest />} />
    </Route>,
    sideBar: true,
    order: 13,

  },],



  "service": [
    // {

    //   to: "/kfh-trade",
    //   icon: <ThemeIcon color="green" variant="light"><IconTool size={16} /></ThemeIcon>,
    //   route: <Route key="kfh-trade_root" path="/kfh-trade" >
    //     <Route key="kfh-trade" index element={<Services />} />
    //     <Route key="kfh-trade/id" path=":id" element={<ServicePage />} />
    //   </Route>,

    //   label: 'Services',
    //   sideBar: true,
    //   order: 4,


    // },
    {

      to: "/services",
      icon: <ThemeIcon color="green" variant="light"><IconTool size={16} /></ThemeIcon>,
      route: <Route key="services_root" path="/services" >
        <Route key="services" index element={<Services />} />
        <Route key="services/id" path=":id" element={<ServicePage />} />
      </Route>,

      label: 'KFH Trade',
      sideBar: true,
      order: 4,


    },
    {
      to: "/services/add_service",
      route: <Route key="add_service_root" path="/services/add_service"  >
        <Route key="add_service" index element={<AddService serviceTypes={["kfhtrade"]} />} />
        <Route key="add_service/id" path=":civilIDParam" element={<AddService />} />
      </Route>,
    },
  ],
  "portfolios": [
    {

      to: "/portfolios",
      icon: <ThemeIcon color="blue" variant="light"><BsBriefcase size={16} /></ThemeIcon>,
      route: <Route key="portfolios_root" path="/portfolios" >
        <Route key="portfolios" index element={<Portfolios />} />
        <Route key="portfolios/id" path=":id" element={<ServicePage />} />
      </Route>,

      label: 'Portfolios',
      sideBar: true,
      order: 5,


    },
    {
      to: "/portfolios/add_portfolio",
      route: <Route key="add_portfolio_root" path="/portfolios/add_portfolio"  >
        <Route key="add_portfolio" index element={<AddPortfolio serviceTypes={["portfolio"]} />} />
        <Route key="add_portfolio/id" path=":civilIDParam" element={<AddPortfolio />} />
      </Route>,
    },
    ,],
  "ipo-requests": [
    {

      to: "/ipo-requests",
      icon: <ThemeIcon color="green" variant="light"><IconReportMoney size={16} /></ThemeIcon>,
      route: <Route key="ipos_root" path="/ipo-requests" >
        <Route key="ipo-requests" index element={<IposRequests />} />
        <Route key="ipo-requests/id" path=":id" element={<IpoRequestPage />} />
      </Route>,

      label: 'Ipo Requests',
      sideBar: true,
      order: 16,


    },
  ]
  ,

  "settings": [{
    to: "/settings",
    icon: <ThemeIcon color="grape" variant="light"><IconSettings size={16} /></ThemeIcon>,
    label: 'Settings',
    route: <Route key="settings" path="/settings" element={<Settings />} />,
    sideBar: true,
    order: 12,
  },],

  "rms": [{
    icon: <ThemeIcon color="red" variant="light"><IconUserCog size={16} /></ThemeIcon>,
    label: 'KFH RM',
    to: "/kfh-rms",
    route: <Route key="kfh-rms" path="/kfh-rms" element={<RMsListPage />} />,
    sideBar: true,
    order: 11,
  },],


  "qr": [{
    icon: <ThemeIcon color="red" variant="light"><IconUserCog size={16} /></ThemeIcon>,
    label: 'QR',
    to: "qr/verify",
    route: <Route key="verify" path="/qr/verify" element={<VerifyQR />} />,
    sideBar: false

  },],

  // {
  //   icon: <ThemeIcon color="black" variant="light"><IconMail size={16} /></ThemeIcon>,

  //   to: "/communication",
  //   label: "Communication",

  //   route: <Route key="communication" path="/communication" element={<CommunicationForm />} />,
  // },
  //two-way WhatsApp chat inbox; add "whatsapp" to config/routesPermissions for
  //the claims that should see it (cr + admin for now, matching firestore rules)
  "whatsapp": [{
    to: "/whatsapp",
    icon: <ThemeIcon color="green" variant="light"><IconBrandWhatsapp size={16} /></ThemeIcon>,
    label: 'WhatsApp',
    route: <Route key="whatsapp" path="/whatsapp" element={<WhatsappInbox />} />,
    sideBar: true,
    order: 6.5,
  },],

  //Commodity Trading Center (replaces the legacy KFH-NEW-CTC app). Add "ctc" to
  //config/routesPermissions for the ctc_* claims — utils/addCtcRoutesPermission.cjs does it.
  //Design and phases: docs/ctc-module-plan.md
  "ctc": [{
    to: "/ctc",
    icon: <ThemeIcon color="orange" variant="light"><IconBuildingWarehouse size={16} /></ThemeIcon>,
    label: 'CTC',
    route: <Route key="ctc_root" path="/ctc" element={<Ctc />}>
      <Route key="ctc" index element={<CtcWatchList />} />
      <Route key="ctc/orders" path="orders" element={<CtcOrders />} />
      <Route key="ctc/orders/new" path="orders/new" element={<CtcNewOrder />} />
      <Route key="ctc/orders/id" path="orders/:id" element={<CtcOrder />} />
      <Route key="ctc/orders/id/edit" path="orders/:id/edit" element={<CtcNewOrder />} />
      <Route key="ctc/transactions" path="transactions" element={<CtcTransactions />} />
      <Route key="ctc/backoffice" path="backoffice" element={<CtcBackOffice />} />
      <Route key="ctc/reports" path="reports" element={<CtcReports />} />
    </Route>,
    sideBar: true,
    order: 6.7,
  },],

  "communications": [{
    to: "/campaigns",
    route: <Route key="campaigns_root" path="/campaigns"  >
      <Route key="campaigns" index element={<Campaigns />} />
      <Route key="campaigns/create" path="create/" element={<CreateCampaign />} />
      <Route key="campaigns/edit/:campaignId" path="edit/:campaignId" element={<CreateCampaign />} />

      {/* <Route path="add" element={<TransactionsPanel />} /> */}
    </Route>,
    icon: <ThemeIcon color="blue" variant="light"><IconSpeakerphone size={16} /></ThemeIcon>,
    label: 'Campaigns',
    sideBar: true,
    order: 7,

  },

  ],
  "factsheets": [
    {
      icon: <ThemeIcon color="blue" variant="light"><IconBrandWindows size={16} /></ThemeIcon>,
      label: 'Fund Factsheets',
      to: "/funds-reports",
      sideBar: true,
      order: 8,
      route:

        <Route path="/funds-reports">
          <Route key="funds-reports" index element={<FundReportsList />} />
          <Route key="funds-reports-add" path="create" element={<AddFundReport />} />
        </Route>
      ,
    },],
  "funds": [
    {
      icon: <ThemeIcon color="orange" variant="light"><IconAntenna size={16} /></ThemeIcon>,
      label: 'Funds',
      to: "/funds",
      route: <Route key="funds" path="/funds" element={<FundsList />} />,
      sideBar: true,
      order: 9,
    }
    ,],
  //ETF operations.  Add "etf" to config/routesPermissions for the ETF team's claims to enable it.
  //Phase 2 adds requests/approvals/api-status as sibling nested routes (see docs/ETF_PHASE_2.md).
  "etf": [
    {
      icon: <ThemeIcon color="grape" variant="light"><IconPackage size={16} /></ThemeIcon>,
      label: 'ETFs',
      to: "/etf",
      sideBar: true,
      order: 9.5,
      route:
        <Route key="etf" path="/etf" element={<EtfPage />} />
      ,
    },],

  "other":
    [{
      icon: <ThemeIcon color="blue" variant="light"><IconBeach size={16} /></ThemeIcon>, label: 'Flow Editor',

      to: "/flow_editor",
      route: <Route key="flow_editor"
        path="/flow_editor"
        element={<FlowEditor />} />,
      sideBar: true,
      order: 18,
    },],

  "securities": [{
    to: "/securities", label: 'Securities', sideBar: true, order: 9.6,
    icon: <ThemeIcon color="gray" variant="light"><IconPackage size={16} /></ThemeIcon>,
    route: <Route key="securities" path="/securities" element={<SecuritiesList />} />,
  }],
  "transactions": [{
    to: "/transactions",

    route: <Route key="transactions_root" path="/transactions"  >
      <Route key="transactions" index element={<TransactionsList />} />
      <Route key="transactions/add" path="add/" element={<TransactionForm />} />
      <Route key="transactions/add/id" path="add/:customerID" element={<TransactionForm />} />
      <Route key="transaction/id" path=":transactionID" element={<TransactionDetails />} />
    </Route>,
    icon: <ThemeIcon color="gray" variant="light"><IconMoneybag size={16} /></ThemeIcon>,
    label: 'Transactions',
    sideBar: true,
    order: 5,

  },],
  "support": [
    {
      icon: <ThemeIcon color="orange" variant="light"><IconBulb size={16} /></ThemeIcon>,
      label: 'Fekra',
      to: "/feedback",
      route: <Route key="feedback" path="/feedback" element={<CreateFeedback />} />,
      sideBar: true,
      order: 17,
    },
  ],
  "product_catalogue": [{
    icon: <ThemeIcon color="violet" variant="light"><IconPackage size={16} /></ThemeIcon>,
    label: 'Product Catalogue',
    to: "/products",
    route: <Route key="product_catalogue" path="/products" element={<ProductCatalogue />} />,
    sideBar: true,
    order: 8.5,
  }],
  "statistics": [{
    icon: <ThemeIcon color="blue" variant="light"><IconReport size={16} /></ThemeIcon>, label: 'Reports',
    to: "/reports",
    route: <Route key="reports_root" path="/reports">
      <Route key="reports" index element={<Reports />} />
      <Route key="report_print" path=":reportId/print" element={<GenevaReportPrintPage />} />
    </Route>,
    sideBar: true,
    order: 15,
  },
  ],


  "manual": [
    {
      icon: <ThemeIcon color="orange" variant="light"><IconHandGrab size={16} /></ThemeIcon>,
      label: 'Manual',
      to: "/manual",
      route: <Route key="manual" path="/manual" element={<ManualConsent />} />,
      sideBar: true,
      order: 6,
    }],

  "trades": [
    {
      icon: <ThemeIcon color="indigo" variant="light"><IconMoneybag size={16} /></ThemeIcon>,
      label: 'Trades',
      to: "/trades",
      route: <Route key="trades" path="/trades" element={<Trades />} />,


      sideBar: true,
      order: 10,
    },
  ],
  "global_dpm": [
    {
      icon: <ThemeIcon color="indigo" variant="light"><IconReportMoney size={16} /></ThemeIcon>,
      label: 'Global DPM',
      to: "/global-dpm",
      route: <Route key="global-dpm" path="/global-dpm" element={<GlobalDpmRebalancePage />} />,
      sideBar: true,
      order: 10.5,
    },
  ],
  "kyc_configuration": [{
    icon: <ThemeIcon color="red" variant="light"><IconUserCog size={16} /></ThemeIcon>,
    label: 'KYC Configuration',
    to: "/kyc_configuration",
    sideBar: true,
    order: 14,
    route: <Route key="kyc_configuration" path="/kyc_configuration">
      <Route key="kyc_configuration" index element={<KYCConfiguration />} />
      <Route key="kyc_configuration/add_page" path="add_page/" element={<AddPageForm />} />
      <Route key="kyc_configuration/add_page/id" path="add_page/:pageID" element={<AddPageForm />} />
      <Route key="kyc_configuration/add_product" path="add_product/" element={<AddProductForm />} />
      <Route key="kyc_configuration/add_product/id" path="add_product/:productID" element={<AddProductForm />} />
    </Route>
  },],

  "cram_configuration": [{
    icon: <ThemeIcon color="gray" variant="light"><IconScale size={16} /></ThemeIcon>,
    label: 'CRAM Configuration',
    to: "/cram_configuration",
    sideBar: true,
    order: 14.5,
    route: <Route key="cram_configuration" path="/cram_configuration" element={<CramConfiguration />} />,
  },],



};

export const routes = Object.values(routesList).flat()



// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: "675f257f-4d63-41b6-ab23-befdb8a79ced",
    authority: "https://login.microsoftonline.com/organizations",

    //IMPORTANT NOTE!  This freakin' line down here is REALLY important to get right.  Microsoft authentication will NOT work if you change domains.  You'll need to add it to the redirects in Azure AD and add THAT here, even if it's a bullshit redirect.
    redirectUri: import.meta.env.VITE_MICROSOFT_REDIRECT_URL,
    navigateToLoginRequestUrl: false, // Prevent redirect loops
    // postLogoutRedirectUri: "/"
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    windowHashTimeout: 60000, // Applies just to popup calls - In milliseconds
    iframeHashTimeout: 60000, // Applies just to silent calls - In milliseconds
    loadFrameTimeout: 60000, // Applies to both silent and popup calls - In milliseconds
    //allowNativeBroker: false, // Disables WAM Broker new version removed this
    allowRedirectInIframe: true // Allow redirects in iframe
  }

};



// // Add here scopes for id token to be used at MS Identity Platform endpoints.
// export const loginRequest: PopupRequest = {
//   scopes: ["User.Read"]
// };

// // Add here the endpoints for MS Graph API services you would like to use.
// export const graphConfig = {
//   graphMeEndpoint: "https://graph.microsoft-ppe.com/v1.0/me"
// };



export let msalInstance = new PublicClientApplication(msalConfig);
let isMsalInitialized = false;
// const getMsalInstance = async () => {

//   const msalClient = new PublicClientApplication(msalConfig);
//   return await msalClient.initialize();
// }

// export const msalInstance = getMsalInstance();





// let allowedGroups = ["07adab0d-322f-4bf0-907a-5911cf746d99"];




function Login() {


  let provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({
    prompt: "select_account",
    tenant: "organizations",
  })

  // provider.addScope('user.read.all');



  // const app = initializeApp(getFirebaseConf());
  // const auth = getAuth(app);


  //this is if we want to log in using Microsoft Azure AD
  function showSignIn() {

    signInWithRedirect(auth, provider)
      .then((result) => {
        console.log("signin result was", result);

        // User is signed in.
        // IdP data available in result.additionalUserInfo.profile.

        // Get the OAuth access token and ID Token
        const credential = OAuthProvider.credentialFromResult(result);
        if (credential) {
          const accessToken = credential.accessToken;
          const idToken = credential.idToken;

          console.log(accessToken, idToken);
        }
      })
      .catch((error) => {
        console.log("Error was", error)
        // Handle error.
      });
  }




  return (

    <Container size={460} my={30}>
      <Image src={import.meta.env.VITE_WEB_LOGO} alt="logo" />
      <Title ta="center">
        Hello!
      </Title>
      <Text c="dimmed" size="sm" ta="center">
        Let's sign in
      </Text>

      <Paper withBorder shadow="md" p={30} radius="md" mt="xl">
        <Divider label="Microsoft work account" labelPosition="center" my="lg" />

        <Group grow className={classes.controls}>
          <Button onClick={showSignIn} color={import.meta.env.VITE_MAIN_COLOR ?? '#AA9F8E'} leftSection={<IconBrandWindows />} className={classes.control}>Log in with Microsoft</Button>
        </Group>
        {(import.meta.env.VITE_HIDE_PASSWORD_LOGIN !== "true") && < >

          <Divider label="KFH users with email & password" labelPosition="center" my="lg" />
          <EmailLogin />
        </>}
      </Paper>
    </Container>

  )
}



function makeMicrosoftClient(accessToken: string): Client {
  return Client.init({
    defaultVersion: "v1.0",
    debugLogging: true,
    authProvider: (done) => {
      done(null, accessToken);
    },
  });
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();


  // import.meta.env.VITE_TYPESENSE_ORDERS_COLLECTION = "orders"

  useEffect(() => {
    document.title = "KFHC Portal";
    if (import.meta.env.MODE !== 'production') document.title = "KFHC Portal (LOCAL)";
    else if (import.meta.env.VITE_ENV === 'development') document.title = "KFHC Portal (TEST)";
  }, []);


  const [userData, setUserData] = useState<UserDataType>({
    pdf: null, user: null, microsoftClient: null, getAzureADToken: async (userData: UserDataType): Promise<string | undefined> => {
      //The reason this is here because sometimes the Azure AD token expires and becomes invalid for any subsequent calls to the API.
      //I'm just checking this here and refreshing when we need to.
      //Also, the reason I'm passing in userData is because SOMEHOW the userData in state keeps spitting out null values.  
      //I thought userData up top was a reference, but apparently it's not.

      //ok let's check if msal is there in the first place.  If not, return null


      if (!userData.msal) {
        console.log("Somehow we don't have msal in userData.", userData);
        return;
      }

      //ok let's check if we have a token already.  
      let token: string = userData.msal.accessToken;
      if (token) {
        //check if it's expired
        if (userData.msal.expiresOn!.getTime() > new Date().getTime()) {
          // return token;  //no returns, we need token for setUserData
        }
        else if (userData.user) {
          //let's refresh it, somehow.
          let msal = await microsoftAuth(userData.user);
          token = msal!.accessToken;


        }



        setUserData({ ...userData, microsoftClient: makeMicrosoftClient(token) });

        return token;
      }

      return;
    },
  });
  const [configData, setConfigData] = useState<ConfigDataType>({});
  const [globalData, setGlobalData] = useState<GlobalDataType>({});
  const [presenceData, setPresenceData] = useState<Record<string, Viewer[]>>({});
  const [allActiveUsers, setAllActiveUsers] = useState<string[]>([]);





  functions.region = "europe-west1";



  //firebase functions onRequest stuff
  let apiUrl;

  if (import.meta.env.MODE !== 'production') {
    apiUrl = `https://${functions.region}-kfh-capital-crm-test.cloudfunctions.net`;
    const OVERRIDE_FIREBASE = (import.meta.env.VITE_OVERRIDE_FIREBASE_CONFIG === "true" || import.meta.env.VITE_OVERRIDE_FIREBASE_CONFIG === "True")
    if (
      OVERRIDE_FIREBASE
    )
      apiUrl = `http://localhost:5001/kfh-capital-crm-test/${functions.region}`


  }
  else if (import.meta.env.VITE_ENV !== 'production') {
    apiUrl = `https://${functions.region}-kfh-capital-crm-test.cloudfunctions.net`;
  }
  else if (import.meta.env.VITE_ENV === 'production') {
    apiUrl = `https://${functions.region}-kfh-capital-crm.cloudfunctions.net`;
  }



  const appConfig: AppConfigType = { apiUrl }



  const auth = getAuth(app);

  let provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({
    prompt: "select_account",
    tenant: "organizations",
  })

  const [needsLogin, setNeedsLogin] = useState<boolean>(false);
  const [needsTokenRefresh, setNeedsTokenRefresh] = useState<boolean>(true);
  const [availableRoutes, setAvailableRoutes] = useState<any>([]);

  const db = firestore;

  const customClaimsCall = httpsCallable<CustomClaimsRequest, CustomClaimsResult>(functions, 'customClaims');


  //listen to config
  useEffect(() => {
    if (!userData.user?.email) {
      return;
    }

    const configCollection = collection(db, "config");

    return onSnapshot(configCollection, (snapShot) => {
      let configData: any = {};
      snapShot.docs.forEach(doc => {
        configData[doc.id] = doc.data();
      });
      setConfigData(configData);
    })
    /*
    useFirestoreCollection(configCollection)
    const { status, data: config } = useFirestoreCollectionData(configCollection, {
      idField: 'id', // this field will be added to the object created from each document
    });
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.user?.email]);

  //listen to funds
  useEffect(() => {
    if (!userData.user?.email) {
      return;
    }

    const fundsCollection = collection(db, "funds");

    return onSnapshot(fundsCollection, (snapShot) => {
      let globalData: GlobalDataType = {};
      let fundsMap: GlobalDataType["fundsMap"] = {} as GlobalDataType["fundsMap"];
      const fundData = snapShot.docs.map((doc) => {
        const row = doc.data() as Fund;
        row.code = doc.id;
        fundsMap![doc.id] = row;
        return row;
      });

      console.log("fundsMap  ORIGINAL=======>>", fundsMap);


      globalData.funds = fundData;
      globalData.fundsMap = fundsMap;
      globalData.privateFunds = fundData?.filter((fundObj) => fundObj.private);
      globalData.publicFunds = fundData?.filter((fundObj) => !fundObj.private);
      setGlobalData(globalData);
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.user?.email]);

  // Listen to presence data




  let tokenRefresher: NodeJS.Timeout | null = null;


  let getCustomClaims = async (user: User, microsoftToken?: string) => {
    //send auth data to firebase custom claims function at customClaims

    //this sets the claims for the user based on the user's microsoft account (group, id, whatever).  we retrieve it later in firebaseTokenResult.claims.customClaims
    //It also retrieves the searchKey for Algolia

    try {

      const claimsResult = await customClaimsCall({ token: microsoftToken });

      console.log(claimsResult);

      // setLoadingMsg("Authorizing...");

      // Only force a token re-issue when the function actually rewrote the
      // claims — forced refreshes on every load fed the auth quota errors.
      // (claimsChanged missing means an older function build: force, to be safe.)
      let firebaseTokenResult = await user?.getIdTokenResult(claimsResult.data.claimsChanged !== false);
      setUserData(prevState => ({ ...prevState, firebaseTokenResult: firebaseTokenResult, customSearchKey: claimsResult.data.customSearchKey, securitiesSearchKey: claimsResult.data.securitiesSearchKey, rmsCollectionSearchKey: claimsResult.data.rmsCollectionSearchKey, customerCollectionSearchKey: claimsResult.data.customerCollectionSearchKey, ctcSearchKey: claimsResult.data.ctcSearchKey, campaignsSearchKey: claimsResult.data.campaignsSearchKey, availableTradeAccounts: claimsResult.data.availableTradeAccounts, servicesSearchKey: claimsResult.data.servicesSearchKey }));

      console.log("I think we refreshed our token", firebaseTokenResult.claims);
      setNeedsTokenRefresh(false);

      let customClaims = firebaseTokenResult.claims.customClaims;


      if (!customClaims || Object.keys(customClaims).length === 0) {
        setLoadingMsg("You're not authorized to use this app.");
      }
      else {
        //We're good to go!
        setLoadingMsg("");
      }
    }
    catch (e: any) {
      setLoadingMsg(`Auth failure: ${e.message}`);

      console.log("Custom claims error", e);

    }

  }


  // Prevent interaction_in_progress error
  function safeAcquireTokenRedirect(msalInstance: any, requestScope: any) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
    // Clear interaction flag
    sessionStorage.removeItem("msal.interaction.status");
    msalInstance.acquireTokenRedirect({
      ...requestScope,
      prompt: "select_account",
      redirectUri: msalConfig.auth.redirectUri,
    });
  }

  let microsoftAuth = async (user: User) => {
    let requestScope: SsoSilentRequest = {
      scopes: ["User.Read", "User.Read.All"],
      loginHint: user.email || "",
      prompt: "none",
    };

    try {
      if (!isMsalInitialized) {
        await msalInstance.initialize();
        isMsalInitialized = true;
      }


      // Mobile browsers block the third-party cookies ssoSilent's hidden iframe needs, so they
      // fall back to acquireTokenRedirect. Read that redirect's result and reuse cached tokens
      // (refresh token, no iframe) before asking again, or mobile loops on the account picker.
      const redirectResult = await msalInstance.handleRedirectPromise();
      if (redirectResult) navigate("/", { replace: true }); // we land on the redirectUri path
      const account = redirectResult?.account ?? msalInstance.getAllAccounts()
        .find(a => a.username.toLowerCase() === user.email?.toLowerCase());
      let msalTokenResponse: any = redirectResult ?? (account
        ? await msalInstance.acquireTokenSilent({ scopes: requestScope.scopes!, account })
        : await msalInstance.ssoSilent(requestScope));

      setUserData(prevState => ({
        ...prevState,
        msal: msalTokenResponse,
        microsoftClient: makeMicrosoftClient(msalTokenResponse.accessToken),
      }));

      if (needsTokenRefresh) {
        await getCustomClaims(user, msalTokenResponse.accessToken);
      }

      if (tokenRefresher) {
        clearTimeout(tokenRefresher);
      }
      let refreshTimer = msalTokenResponse?.expiresOn?.getTime() - Date.now() - 1000 * 60 * 5;
      tokenRefresher = setTimeout(() => {
        microsoftAuth(user);
      }, refreshTimer);

      return msalTokenResponse;
    } catch (error: any) {
      const accounts = msalInstance.getAllAccounts();

      if (
        error instanceof InteractionRequiredAuthError ||
        (error instanceof BrowserAuthError && error.errorCode === "interaction_in_progress")
      ) {
        console.warn("Silent auth failed, trying redirect", error);
        safeAcquireTokenRedirect(msalInstance, requestScope);
      } else {
        console.error("Unknown error during MSAL auth", error);
        msalInstance.clearCache();
        safeAcquireTokenRedirect(msalInstance, requestScope);
      }
    }
  };

  useEffect(() => {
    console.log("Rerendering");
    let unsubscribe = auth.onAuthStateChanged(user => {
      console.log("Authstate changed!", user);
      setNeedsLogin(!user);
      // console.log(user);
      setUserData(prevState => ({ ...prevState, user }));

      // console.log("user is", user);

      if (user?.providerData[0]?.providerId === "microsoft.com") {
        microsoftAuth(user);
      }
      else if (user) {
        getCustomClaims(user);
      }
    })
    // console.log(unsubscribe);
    return () => {
      console.log("unsubbed from authstate changes");
      unsubscribe()
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const [loadingMsg, setLoadingMsg] = useState<string>("Logging in...");




  const customClaims = useMemo(() =>
    userData.firebaseTokenResult?.claims.customClaims || {} as CustomClaims,
    [userData.firebaseTokenResult?.claims.customClaims]
  );
  const routePermissions = configData?.routesPermissions;
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const isPrintRoute = /^\/reports\/[^/]+\/print$/.test(location.pathname);

  useEffect(() => {
    if (routePermissions) {
      const customArrayRoutes = resolveAvailableRouteKeys(routePermissions, customClaims);
      const newRoutes = customArrayRoutes.map((routeKey: string) => routesList[routeKey]).flat();
      setAvailableRoutes(newRoutes);
      if (import.meta.env.MODE === 'development') {
        // console.log("NEW ROUTES ===========>>", newRoutes);
      }
    }
  }, [routePermissions, customClaims])

  const renderedRoutes = (
    <Routes>
      {availableRoutes.map((route: any,) => {
        const claims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

        if (!route?.route) return null;
        // Home hidden for this build: "/" opens the first menu item the user has instead
        if (route.to === "/" && isFeatureHidden("home")) {
          const first = availableRoutes.find((r: any) => r?.sideBar && r.to && r.to !== "/");
          return <Route key="root" path="/" element={first ? <Navigate to={first.to} replace /> : <Home />} />;
        }

        let exists = false;

        for (const claimString in claims) {
          const claim = claimString as ClaimType;

          if (claims[claim] === true) {
            exists = true;
            break;
          }

          if (!exists) return null;
        }

        return route?.route;
      })}

      <Route
        path="*"
        element={
          <main>
            <p>Hi.  There's nothing here.</p>
          </main>
        }
      />
    </Routes>
  );


  return (
    <>
      <ColorSchemeScript defaultColorScheme="light" />

      <MantineProvider defaultColorScheme="light">

        <CustomerSpotlight userData={userData} />

        <Notifications />

        <FirebaseProvider>
          {/* <Container fluid> */}
          <MyUserDataContext.Provider value={userData}>
            <ConfigContext.Provider value={configData}>
              <AppConfigContext.Provider value={appConfig}>
                <GlobalDataContext.Provider value={globalData}>
                  <PresenceTracker />
                  {/* <ModalsProvider>  changed to be put inside the context wrappers so i can use the context inside modals*/}
                  <ModalsProvider>
                    {needsLogin ? <Login /> : loadingMsg !== "" ?


                      <Center style={{ height: 500 }}>

                        <Stack gap="xl" ta="center">
                          <Image style={{ width: 500 }} src={import.meta.env.VITE_WEB_LOGO} alt="logo" />
                          <div
                            style={{ width: "100%", display: "flex", justifyContent: "center" }}
                          >

                            <Loader


                              size='xl' color={import.meta.env.VITE_MAIN_COLOR ?? '#AA9F8E'} type='bars' />

                          </div>
                          <Text c="dimmed" size="xl" ta="center">
                            {loadingMsg}

                          </Text>
                        </Stack>

                      </Center>

                      :



                      // <LoadingOverlay visible={true} overlayBlur={2}>

                      isPrintRoute ? renderedRoutes : <AppShell
                        padding="md"
                        header={{ height: 100, }}
                        navbar={{
                          width: "14rem",
                          breakpoint: 'sm',
                          collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
                        }}
                      >
                        <AppShell.Header
                          px={"xs"}
                        >
                          <Group
                            h={"100%"}
                            wrap={"nowrap"}
                          >
                            <Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
                            <Burger opened={desktopOpened} onClick={toggleDesktop} visibleFrom="sm" size="sm" />

                            <Topbar />
                          </Group>
                        </AppShell.Header>
                        <AppShell.Navbar
                          p={"md"}
                        >
                          <AppShell.Section grow component={ScrollArea}>
                            {routePermissions && <MainLinks />}
                          </AppShell.Section>
                          <VersionChecker />
                        </AppShell.Navbar>
                        <AppShell.Main
                          style={{
                            background: 'rgb(248, 249, 250)',
                            minHeight: 'calc(100dvh - var(--app-shell-header-height))',
                            overflow: 'auto',
                          }}
                        >
                          {renderedRoutes}
                        </AppShell.Main>
                      </AppShell>
                    }
                  </ModalsProvider>
                </GlobalDataContext.Provider>
              </AppConfigContext.Provider>
            </ConfigContext.Provider>
          </MyUserDataContext.Provider>

          {/* </Container> */}
        </FirebaseProvider>


      </MantineProvider>
    </>

  );
}

export default App;
